import React from "react";

type SynchronizedLineProps = {
  text: string;
  phase: "typing" | "pauseAfterTyping" | "deleting" | "pauseAfterDeleting";
  progress: number;
  color?: string;
};

const SynchronizedLine: React.FC<SynchronizedLineProps> = ({
  text,
  phase,
  progress,
  color = "#ffffff",
}) => {
  let displayed = "";

  if (phase === "typing") {
    const len = Math.floor(progress * text.length);
    displayed = text.slice(0, len);
  } else if (phase === "pauseAfterTyping") {
    displayed = text;
  } else if (phase === "deleting") {
    const len = Math.ceil((1 - progress) * text.length);
    displayed = text.slice(0, len);
  } else if (phase === "pauseAfterDeleting") {
    displayed = "";
  }

  const showCursor = displayed.length > 0;

  return (
    <div className="typewriter-line mb-2" style={{ color }}>
      <span>{displayed}</span>
      {showCursor && <span className="typewriter-cursor"></span>}
    </div>
  );
};

export default SynchronizedLine;
